<template lang="pug">
  .section-layout
    div.customer-title
      .nav-back-btn(@click="goBack")
      h2 报名用户
    .section-filter
      .field-group.is-horizontal
        .field.name_keyword-wrapper
          label.label 关键字搜索
          custom-input(v-model="keyword", placeholder="请输入用户昵称/电话", @keyupEnter="applyFilter")
        .field
          a.button.primary(@click="applyFilter") 搜索
        .field
          a.button(@click="resetFilter") 重置
        .field
          a.button(@click="exportData") 导出
    empty-page(v-if="!list.length", :tip="'当前没有报名用户'")
    .content-wrapper.list-wrapper(v-if="list && list.length")
      .table-wrapper
        table.table
          thead
            tr
              td(width="200") 客户信息
              td(width="150") 车牌号
              td(width="300") 车型信息
              td(width="150") 报名时间
              td(width="300") 参与门店
          tbody(v-if="list.length")
            tr(v-for="(item, index) in list")
              td
                .simple-td(v-text="item.nick_name")
                .simple-td.max-160(v-text="item.mobile")
              td
                div {{item.license_plate || '--'}}
              td
                div {{item.vehicle_name || '--'}}
              td
                .simple-td {{(item.created_at - 0) | date("yyyy-MM-dd HH:mm:ss", "cn")}}
              td
                div {{item.store_name ? item.store_name : '--'}}
        .tfoot(v-if="list.length")
          pagination(:pagination-data="pagination_data", @input="paging")
</template>

<script>
import Api from '@/mixins/modules/Content'
import CustomInput from '@/components/generics/form/CustomInput'
import Pagination from '@/components/generics/Pagination'
import EmptyPage from '@/components/generics/EmptyPage'
import { root } from '@/plugins/Fetch'
import ExportApi from '@/mixins/modules/export'

/**
 * @vue
 */
export default {
  name: 'ContentCustomer',
  mixins: [Api, ExportApi],
  components: {
    CustomInput,
    Pagination,
    EmptyPage,
  },
  data () {
    return {
      root,
      activity_id: '', // 活动id
      keyword: '',
      list: [],
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 2,
        total: 0,
      },
    }
  },
  computed: {
  },
  methods: {
    // 分页
    paging () {},
    // 搜索
    applyFilter () {
      this.pagination_data.current_page = 1
      this.fetchData()
    },
    // 重置
    resetFilter () {
      this.keyword = ''
      this.pagination_data.current_page = 1
      this.fetchData()
    },
    // 导出
    exportData () {
      // window.open(`${root}/activity/activity_customer_export?activity_id=${this.activity_id}`)
      this.exportActivityCustomer(`activity_id=${this.activity_id}`)
    },
    async fetchData () {
      try {
        const { response, result } = await this.GetActivityCustomerListApi({
          activity_id: this.activity_id,
          keyword: this.keyword,
          page: this.pagination_data.current_page,
          per_page: this.pagination_data.per_page,
        })
        if (response.status === 200 && result.code === 0) {
          this.list = result.data
          this.pagination_data = result.meta
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取报名用户列表失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取报名用户列表失败',
          content: `错误: ${err}`,
        })
      }
    },
    // 返回
    goBack () {
      this.$router.push({
        name: 'contentList',
        query: {
          save: 1,
        },
      })
    },
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.fetchData()
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins';
.customer-title
  display flex
  align-items center
  padding 20px 20px 20px 24px
  h2
    margin-left 14px
.nav-back-btn
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, .08)
  cursor pointer
  z-index 2
.icon-img
  height: 36px
.icon-img img
  width: 36px
  height: 36px
.max-160
  max-width 160px !important
.max-280
  max-width 280px !important
</style>



// WEBPACK FOOTER //
// src/components/content/ContentCustomer.vue